import React from 'react';
import TooltipInfo from "Components/Common/components/TooltipInfo"
import { TTableHeaderProps } from "types/Components/Common/Table/Table"
import { conditionalStyle } from "../utils"
import TableHeaderControlModal from "./TableHeaderControlModal"
import { IndeterminateCheckbox } from "Components/Table/Components/IndeterminateCheckbox"
import TableHeaderControlButton from "./TableHeaderControlButton"
import CustomAttributeTag from "Components/Common/CustomAttributeTag"


/**
 * Common table header with header management option
 * 
 * @param param0 
 * @returns 
 */
export default function TableHeaders ({
    options, 
    headers, 
    setHeaderControlOpen, 
    headerControlOpen, 
    handleSave,
    rows,
    handleSelectAll,
    selectedAllCondition,
    defaultHeaders}: TTableHeaderProps) {

    const selected = !options?.disableheaderSelectAll && selectedAllCondition && selectedAllCondition(rows)

    return (
        <>
            {/* Header band on the DS Table's own dark-header grammar: tone-neutral-tint ground,
                ink-tertiary labels (the legacy #6B778C IS ink-tertiary's light value). */}
            <thead className={`tw-sticky tw-top-0 tw-z-[1001] tw-text-ink-tertiary`}>
                <tr>
            {
                options?.selectable &&
                <th className={`${options?.headerClassName ?? ""} tw-bg-tone-neutral-tint  tw-sticky tw-left-0 tw-h-full`}>
                    <div  style = {{paddingLeft: options?.firstColPaddingLeft ?? 0}} className={`${options?.headerClassName ?? ""} tw-w-12 tw-text-center tw-max-h-min`}>
                    {
                        !options?.disableheaderSelectAll &&
                        <IndeterminateCheckbox aria-label="Select all rows" checked={selected === 1 && "checked"}  indeterminate={selected === 0}  onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleSelectAll && handleSelectAll(e, rows)}/>
                    }
                    </div>
                </th>
            }
            {
                headers?.filter((header) => header.display).map((header, key) => (
                    /* Label grammar = the DS TableHeader's: title-header (14px/600) in
                       ink-secondary, as-authored casing — the uppercase <h3> was the legacy
                       look. The classes sit on the <th>, NOT the label span, so a consumer's
                       headerClassName (AccordionTable's compact `tw-text-xs !tw-text-ink-tertiary`)
                       still wins through inheritance exactly as before. */
                    <th key={key} className={`${options?.headerClassName ?? ""} tw-bg-tone-neutral-tint tw-text-title-header tw-text-ink-secondary tw-whitespace-nowrap`}
                        style={conditionalStyle(header.options)}
                    >
                        <div
                        style={{width: header.options?.width ?? "auto"}}
                        className={`tw-py-3 tw-flex tw-space-x-2 tw-items-center tw-px-2 tw-pr-6
                            ${options?.headerClassName ?? ""}
                            ${header.options?.sticky?.[0] ? "tw-shadow-r" : ""}
                            ${header.className ?? ""}`}
                        >
                            {
                                /* Prefix, not suffix — the same placement Data Review uses before a
                                   custom attribute's name (AB#13810), kept identical here so one
                                   glyph means one thing everywhere (AB#14859). */
                                header.options?.isCustom &&
                                <CustomAttributeTag data-testid={`column-custom-tag-${header.name}`} />
                            }
                            <span>{header.name}</span>
                            {
                                (!options?.disableSort && header.sortable) &&
                                <i className={`fas fa-sort tw-text-xs tw-text-ink-tertiary`} />
                            }
                            {
                                header.options?.info && 
                                <TooltipInfo message={header.options.info}/>
                            }
                        </div>
                    </th>
                ))
            }
            {
                !options?.disableRowOptions && <th className={`${options?.headerClassName ?? ""} tw-bg-tone-neutral-tint tw-sticky tw-right-0 tw-rel  tw-text-center tw-z-10 `}>
                    <div className={`tw-absolute tw-top-0 tw-right-full tw-h-full tw-bg-gradient-to-r tw-w-[100px] tw-from-transparent tw-pointer-events-none ${options?.headerStickyToClassName ?? "tw-to-tone-neutral-tint"}`}></div>
                    { !options?.accordion && 
                        <TableHeaderControlButton
                            disableHeaderControls={options?.disableHeaderControls}
                            setHeaderControlOpen={setHeaderControlOpen}
                    />
                    }
                </th>
            }
            { 
            options?.accordion && <th className={`${options?.headerClassName ?? ""} tw-bg-tone-neutral-tint tw-sticky tw-right-0 tw-rel tw-text-center tw-z-10 tw-max(40px,100%)`}>
                {
                    !options?.disableHeaderControls && 
                    <TableHeaderControlButton
                        disableHeaderControls={options?.disableHeaderControls}
                        setHeaderControlOpen={setHeaderControlOpen}
                    />
                }
            </th>
            }
            </tr>
        </thead>
        {
            (!options?.disableHeaderControls && headerControlOpen) && 
            <TableHeaderControlModal
                headers={headers}
                handleSave={handleSave}
                defaultHeaders = {defaultHeaders}
                headerControlOpen={headerControlOpen}
                setHeaderControlOpen={setHeaderControlOpen}
            /> 
        }
    </>
    )
}